<div class="tw-flex tw-items-start tw-gap-3">
    <div #formContainer class="tw-flex-1">
        <form
            [formGroup]="businessProfileForm"
            (ngSubmit)="onSubmit($event, businessProfileForm.value)"
            class="tw-flex tw-flex-col tw-gap-0 md:tw-gap-[28px]"
        >
            <div class="tw-block tw-w-[100%]">
                <div
                    class="tw-flex tw-gap-3 tw-items-center tw-justify-end tw-mt-4 tw-mb-5"
                >
                    <button
                        *ngIf="!isEditing"
                        (click)="onEditBusinessInfo()"
                        class="tw-py-[10px] tw-px-6 tw-rounded-full tw-text-[16px] tw-font-bold tw-bg-[#0A0A75] tw-text-white"
                    >
                        {{ "PROFILE.EDIT_PROFILE" | translate }}
                    </button>
                    <button
                        *ngIf="isEditing"
                        class="tw-py-[10px] tw-px-6 tw-rounded-full tw-text-[16px] tw-font-bold tw-bg-[#0000001A] tw-text-[#00000066]"
                        (click)="onCancelBusInfoDetails()"
                    >
                        {{ "CANCEL" | translate }}
                    </button>
                    <button
                        *ngIf="isEditing"
                        class="tw-py-[10px] tw-px-6 tw-rounded-full tw-text-[16px] tw-font-bold tw-bg-[#0A0A75] tw-text-white"
                    >
                        {{ "COMMON.SAVE" | translate }}
                    </button>
                </div>
                <div
                    class="tw-w-auto tw-mt-[24px] md:tw-mt-0 tw-flex tw-flex-col tw-gap-[20px]"
                >
                    <label
                        class="tw-block tw-text-[16px] tw-leading-[24px] tw-text-black tw-font-[500] tw-mb-[20px] md:tw-mb-0"
                        >{{
                            "NEW_APPLICATION.BUSINESS_INFO" | translate
                        }}</label
                    >
                    <div class="tw-grid tw-gap-[3px]">
                        <revamp-input-general
                            class="tw-block tw-w-[100%]"
                            [applyDisableText]="!isEditing"
                            [backgroundOverride]="
                                isEditing ? '' : '!tw-bg-[#f4f2f0]'
                            "
                            [businessInfoProfile]="true"
                            [mandatoryField]="true"
                            [label]="'PROFILE.COMPANY_NAME' | translate"
                            [placeHolder]="
                                'NEW_APPLICATION.TYPE_HERE' | translate
                            "
                            [controlName]="'companyName'"
                            [maxlength]="maxCompanyName"
                            [errors]="getErrors('companyName')"
                        />
                    </div>
                    <div class="tw-grid tw-gap-[3px] md:tw-grid-cols-1 tw-mb-0">
                        <div
                            class="tw-flex tw-text-[#7B7575] tw-text-[16px] tw-leading-6"
                        >
                            {{ "PROFILE.COMPANY_ADDRESS" | translate }}
                            <span class="tw-text-red-400">*</span>
                        </div>
                        <textarea
                            class="borderCss tw-max-[640px] tw-h-[144px] tw-w-full tw-overflow-auto tw-rounded-3xl tw-pt-3.5 tw-pb-3.5 tw-px-6"
                            [ngClass]="[
                                isFocus
                                    ? 'focusedBorderCss tw-text-black'
                                    : f.companyAddress !== null
                                    ? 'tw-text-black'
                                    : 'tw-text-caption-gray',
                                isEditing ? 'tw-bg-white' : '!tw-bg-[#f4f2f0]',
                                !isEditing ? 'tw-text-black/[0.24]' : ''
                            ]"
                            placeholder="{{
                                'PLEASE_DESCRIBE_IN_DETAIL' | translate
                            }}"
                            [required]="true"
                            formControlName="companyAddress"
                            [maxlength]="maxCompanyAddress"
                            (focus)="onFocus()"
                            (blur)="onBlur()"
                            appForbiddenChars
                        >
                        </textarea>
                        <div
                            *ngIf="
                                submitted && getErrors('companyAddress').length
                            "
                            class="tw-flex tw-flex-col tw-mt-4"
                        >
                            <div
                                class="tw-flex tw-gap-2 tw-items-center tw-text-black"
                            >
                                <mat-icon
                                    class="error-icon !tw-overflow-visible"
                                    >error_outline</mat-icon
                                >
                                <span>{{
                                    getErrors("companyAddress")[0]
                                }}</span>
                            </div>
                        </div>
                    </div>
                    <div
                        class="tw-grid tw-gap-[20px] md:tw-grid-cols-1 tw-mb-0"
                    >
                        <revamp-input-general
                            class="tw-block tw-w-[100%]"
                            [applyDisableText]="!isEditing"
                            [backgroundOverride]="
                                isEditing ? '' : '!tw-bg-[#f4f2f0]'
                            "
                            [businessInfoProfile]="true"
                            [mandatoryField]="true"
                            [headerUnderline]="false"
                            [label]="
                                'PROFILE.COMPANY_CONTACT_DETAILS' | translate
                            "
                            [placeHolder]="'+(60x) xxx xxxx'"
                            [controlName]="'companyContactDetails'"
                            [errors]="getErrors('companyContactDetails')"
                        />
                    </div>
                    <div
                        class="tw-grid tw-gap-[20px] md:tw-grid-cols-1 tw-mb-0"
                    >
                        <revamp-input-general
                            class="tw-block tw-w-[100%]"
                            [applyDisableText]="!isEditing"
                            [backgroundOverride]="
                                isEditing ? '' : '!tw-bg-[#f4f2f0]'
                            "
                            [businessInfoProfile]="true"
                            [mandatoryField]="true"
                            [label]="'PROFILE.COMPANY_EMAIL' | translate"
                            [placeHolder]="'abc@gmail.com'"
                            [controlName]="'companyEmail'"
                            [errors]="getErrors('companyEmail')"
                        />
                        <revamp-select-general
                            class="tw-block tw-w-[100%]"
                            [applyDisableText]="!isEditing"
                            [backgroundOverride]="
                                isEditing ? '' : '!tw-bg-[#f4f2f0]'
                            "
                            [options]="businessTypeOptions"
                            [label]="
                                'NEW_APPLICATION.BUSINESS_TYPE' | translate
                            "
                            [placeHolder]="
                                'NEW_APPLICATION.DROPDOWN_PLACEHOLDER'
                                    | translate
                            "
                            [currentValue]="businessType"
                            (selectionChange)="
                                handleBusinessTypeOptions($event)
                            "
                            (dropdownToggle)="closeAllDropdowns(2)"
                            [mandatoryField]="true"
                            [controlName]="'businessType'"
                            [errors]="getErrors('businessType')"
                            [isDropdownOpen]="toggleDropDown[2]"
                        />
                    </div>
                    <div
                        class="tw-grid tw-gap-[20px] md:tw-grid-cols-1 tw-mb-0"
                    >
                        <revamp-select-general
                            class="tw-w-full"
                            [applyDisableText]="!isEditing"
                            [backgroundOverride]="
                                isEditing ? '' : '!tw-bg-[#f4f2f0]'
                            "
                            [options]="yesNoOptions"
                            [label]="'REG_IN_SABAH_SARAWAK' | translate"
                            [placeHolder]="
                                'NEW_APPLICATION.DROPDOWN_PLACEHOLDER'
                                    | translate
                            "
                            [currentValue]="yesNoOptionType"
                            (selectionChange)="onSelectSabahSarwak($event)"
                            (dropdownToggle)="closeAllDropdowns(3)"
                            [mandatoryField]="true"
                            [controlName]="'sabahSarwak'"
                            [errors]="getErrors('sabahSarwak')"
                            [isDropdownOpen]="toggleDropDown[3]"
                        />
                        <revamp-select-general
                            class="tw-w-full"
                            [applyDisableText]="!isEditing"
                            [backgroundOverride]="
                                isEditing ? '' : '!tw-bg-[#f4f2f0]'
                            "
                            [options]="businessIndustryOptions"
                            [label]="
                                'NEW_APPLICATION.BUSINESS_INDUSTRY' | translate
                            "
                            [placeHolder]="
                                'NEW_APPLICATION.DROPDOWN_PLACEHOLDER'
                                    | translate
                            "
                            [currentValue]="businessIndustry"
                            (selectionChange)="
                                handleBusinessIndustryOptions($event)
                            "
                            (dropdownToggle)="closeAllDropdowns(0)"
                            [contentUnderline]="false"
                            [headerUnderline]="false"
                            [mandatoryField]="true"
                            [controlName]="'businessIndustry'"
                            [errors]="getErrors('businessIndustry')"
                            [isDropdownOpen]="toggleDropDown[0]"
                        />
                    </div>
                    <div
                        class="tw-grid tw-gap-[20px] md:tw-grid-cols-1 tw-mb-0"
                    >
                        <revamp-select-general
                            class="tw-w-full"
                            [applyDisableText]="!isEditing"
                            [backgroundOverride]="
                                isEditing ? '' : '!tw-bg-[#f4f2f0]'
                            "
                            [options]="numberOfYearsOperationOptions"
                            [label]="
                                'NEW_APPLICATION.NUMBER_OF_YEARS_IN_OPERATION'
                                    | translate
                            "
                            [placeHolder]="
                                'NEW_APPLICATION.DROPDOWN_PLACEHOLDER'
                                    | translate
                            "
                            [currentValue]="numberOfYearsOperation"
                            (selectionChange)="
                                handleNumberOfYearsOperationDetail($event)
                            "
                            (dropdownToggle)="closeAllDropdowns(1)"
                            [contentUnderline]="false"
                            [headerUnderline]="false"
                            [mandatoryField]="true"
                            [controlName]="'yearsOfOperation'"
                            [errors]="getErrors('yearsOfOperation')"
                            [isDropdownOpen]="toggleDropDown[1]"
                        />
                        <revamp-input-general
                            class="tw-block tw-w-[100%]"
                            [applyDisableText]="!isEditing"
                            [backgroundOverride]="
                                isEditing ? '' : '!tw-bg-[#f4f2f0]'
                            "
                            [mandatoryField]="true"
                            [label]="
                                'NEW_APPLICATION.NUMBER_OF_FULL_TIME_EMPLOYEE'
                                    | translate
                            "
                            [placeHolder]="0"
                            [controlName]="'noOfEmployee'"
                            (input)="keyPressNumbers($event)"
                            (paste)="pasteNumberOnly($event)"
                            [maxlength]="maxNoOfEmployee"
                            [errors]="getErrors('noOfEmployee')"
                            [businessInfoProfile]="true"
                        />
                    </div>
                </div>
            </div>
        </form>
    </div>

    <div
        class="tw-hidden tw-bg-[#ffffff] tw-border tw-border-[#D8D8D8] tw-rounded-[24px] tw-min-w-[229px] tw-max-w-[229px] tw-py-[28px] tw-px-[30px] md:tw-flex tw-flex-col tw-gap-[10px] tw-relative tw-top-0"
    >
        <div
            *ngFor="let i of rightSide; let index = index"
            class="tw-flex tw-flex-col tw-gap-[14px]"
        >
            <img
                *ngIf="index == 0"
                class="tw-w-[38px] tw-h-[38px]"
                src="/assets/images/preliminary.png"
                alt="preliminary"
            />
            <img
                *ngIf="index == 1"
                class="tw-w-[38px] tw-h-[38px]"
                src="/assets/images/expand_circle_right.png"
                alt="expand_circle_right"
            />
            <img
                *ngIf="index == 2"
                class="tw-w-[38px] tw-h-[38px]"
                src="/assets/images/done.png"
                alt="done"
            />
            <div class="tw-font-semibold tw-text-[14px]">
                {{ i.title | translate }}
            </div>
            <div class="tw-font-medium tw-text-[12px] tw-mb-[14px]">
                {{ i.subtitle | translate }}
            </div>
            <mat-divider
                *ngIf="index < 2"
                style="margin-bottom: 10px"
            ></mat-divider>
        </div>
    </div>
</div>
